module.exports = __webpack_public_path__ + "static/img/search_1.17b7232.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/search_1.png
// module id = KOvj
// module chunks = 1